const vendorList = [
    { id: '1', label: '龙脉3000GMkey', driver_name: 'mtoken_gm3000.dll', driver_base64: 'bXRva2VuX2dtMzAwMC5kbGw=' },
    { id: '2', label: '海泰方圆', driver_name: 'SKFAPI20083.dll', driver_base64: 'U0tGQVBJMjAwODMuZGxs' },
    {
        id: '3',
        label: '江南天安',
        driver_name: 'mtoken_gm3000_tass.dll',
        driver_base64: 'bXRva2VuX2dtMzAwMF90YXNzLmRsbA==',
    },
];

define([], function () {
    return vendorList;
});


// WEBPACK FOOTER //
// ./public/base/utils/vendorList.js